import { useSuspenseQuery } from '@tanstack/react-query';

import {
  getAbstractValidationOptions,
  useValidateAbstract,
} from '@/module/Author/Abstract/Validation/model/AbstractValidationModel';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

interface ValidationActionProps {
  abstractId: Id;
  variant?: ValidationVariant;
}

export function AbstractValidationAction({ abstractId, variant }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getAbstractValidationOptions(abstractId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateAbstract(abstractId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
